import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';

type Props = {
  render: (healthDeclarationId: string) => ReactElement;
};

const HealthDeclarationRoute = observer(({ render }: Props) => {
  const { healthDeclarationId } = useParams();

  if (!healthDeclarationId) {
    throw new Error('missing');
  }

  return render(healthDeclarationId);
});

export default HealthDeclarationRoute;
